import { type SlideProps, Slide } from "@mui/material";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

export const SlideTransition = forwardRef<
  unknown,
  ComponentPropsWithoutRef<"div"> & SlideProps
>(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
